import React from 'react';
import { faUser, faLock } from '@fortawesome/pro-regular-svg-icons';
import { BaseModal } from '../UI/Modal/BaseModal';
import { SidebarModal, type SidebarModalItem } from '../UI/SidebarModal/SidebarModal';
import PersonalInfoContent from './PersonalInfoContent';
import SecurityContent from './SecurityContent';
import styles from './MyAccountModal.module.scss';
import { Avatar } from 'components/UI/Layout/Avatar';
import { useAuth, getUserInitials } from 'hooks';
import { getAuthUserDisplayName } from 'actions/login/OrganizationsLoginConverter';



interface MyAccountModalProps {
    isOpen: boolean;
    onClose: () => void;
}

export const MyAccountModal: React.FC<MyAccountModalProps> = ({
    isOpen,
    onClose
}) => {
    const auth = useAuth();
    const sidebarItems: SidebarModalItem[] = [
        {
            id: 'personal-info',
            label: 'Personal info',
            icon: faUser,
            content: <PersonalInfoContent />
        },
        {
            id: 'security',
            label: 'Security',
            icon: faLock,
            content: <SecurityContent />
        }
    ];

    const prependSidebarContent = (
        <>
            <div className={styles.myAccountSidebarTopContent}>
                <Avatar className={styles.avatar} initials={getUserInitials(auth)} />
                <h3>{getAuthUserDisplayName(auth)}</h3>
            </div>
            <h2 className={styles.myAccountModalTitle}>Account settings</h2>
        </>
    );

    return (
        <BaseModal
            isOpen={isOpen}
            onClose={onClose}
            className={styles.myAccountModal}
        >
            <BaseModal.Header 
                showLogo={true}
                showCloseButton={true}
            />
            
            <BaseModal.Content className={styles.myAccountMainModalContent}>
                <SidebarModal
                    items={sidebarItems}
                    defaultSelectedId="personal-info"
                    className={styles.myAccountModalContent}
                    prependSidebarContent={prependSidebarContent}
                />
            </BaseModal.Content>
        </BaseModal>
    );
};

export default MyAccountModal;
